import ClimateHeader from "./ClimateHeader";
import FesHeader from "./FesHeader";
import NeolibHeader from "./NeolibHeader";
const CustomHeaders = () => {
  const index = process.env.REACT_APP_PROJECT_INDEX || undefined;
  let componentToRender = <div className="hidden"></div>;
  if (index && index === "fes") {
    componentToRender = <FesHeader />;
  } else if (index && index === "climate") {
    componentToRender = <ClimateHeader />;
  } else if (index && index === "neolib") {
    componentToRender = <NeolibHeader />;
  }
  return componentToRender;
};
export default CustomHeaders;
